<template>
  <div id="container" class="member_st">
    <!-- 개인정보수정 & sub menu -->
    <AccountHead />

    <!-- 쿠폰 관리 START -->
    <div class="section fill">
      <div class="inner df">
        <div class="box_title">
          <h2 class="">쿠폰 코드 등록</h2>
          <div class="input_wrap">
            <label for="cp" class="lb_wrap">
              <!-- <span class="ab_text">{{ couponCd }}</span> -->
              <input
                id="cp"
                v-model.trim="discntNo"
                type="text"
                placeholder="쿠폰 코드를 등록하세요"
                maxlength="19"
                @input="handleDiscountInput"
              />
            </label>
          </div>
          <div>
            <a class="box_btn" @click="requestDiscount">
              <span class="an_t">확인</span>
              <!-- <span class="an_t">확인</span> -->
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="section section2">
      <div class="inner">
        <div class="tit_box">
          <h1>
            사용 가능한 쿠폰
            <b>{{ getAccountDiscountsCount }}</b>
            장
          </h1>
          <ul>
            <li
              :class="{ active: sorting == 'NW' }"
              @click="changeSortCoupon('NW')"
            >
              최근 등록순
            </li>
            <li
              :class="{ active: sorting == 'DL' }"
              @click="changeSortCoupon('DL')"
            >
              마감 임박순
            </li>
          </ul>
          <div class="clear"></div>
        </div>
        <div v-if="getAccountDiscounts" class="coupon_list">
          <div
            v-for="(items, idx) in getAccountDiscounts"
            :key="idx"
            class="coupon_box"
          >
            <div>
              <p v-if="items.discntTp === 'RATE'" class="discount_rate">
                {{ items.discntRate }}%
              </p>
              <p v-else-if="items.discntTp === 'WON'" class="discount_rate">
                {{ items.discntWon }}원
              </p>
              <p v-if="items.discntTitle" class="book_name">
                {{ items.discntTitle }}
              </p>
              <p v-else-if="items.bookCode" class="book_name">
                {{ items.bookName }}
              </p>
              <p v-else class="book_name">
                도서 선택 할인
              </p>
            </div>
            <div>
              <div class="coupon_date">
                * {{ expiredDateFormat(items.expiredTime) }}
              </div>
              <div class="bt" @click="moveToBook(items.bookCode)">
                바로가기
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>

    <!-- ERROR MODAL START -->
    <transition v-on-clickaway="closeErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="closeErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_inner">
              <strong>
                {{ errorMessage }}
              </strong>
              <p>
                {{ subErrMsg }}
              </p>
              <div class="btnWrap">
                <button class="box_btn" @click="closeErrorModal">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
    <!-- ERROR MODAL END -->
  </div>
</template>

<script>
import AccountHead from '../../components/member/AccountHead.vue'
import { mapGetters } from 'vuex'
import { ACCOUNT_DISCOUNT_GET_LIST } from '@/store/types'

export default {
  name: 'Discount',
  components: { AccountHead },
  data() {
    return {
      isValid: true,
      isRefresh: false,
      showErrorModal: false,
      errorMessage: false,
      subErrMsg: '',
      discntNo: '',
      setData: '',
      sorting: 'NW'
    }
  },
  computed: {
    ...mapGetters([
      'getAccountDiscounts',
      'getAccountDiscountsCount',
      'isAccountDiscountsLoading'
    ])
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      await vm.$store.dispatch(ACCOUNT_DISCOUNT_GET_LIST, 'NW')
    })
  },
  methods: {
    async requestDiscount() {
      if (!this.isValid) {
        return
      }
      await this.$store
        .dispatch('requestDiscounte', {
          discntNo: this.discntNo
        })
        .then((res) => {
          if (res.data.ok) {
            this.errorMessage = '쿠폰 등록이 완료되었습니다.'
            this.subErrMsg = '할인 가능 도서를 확인해주세요.'
            this.isRefresh = true
            this.toggleErrorModal()
          }
        })
        .catch((err) => {
          console.log(err.response.data.errorState.message)
          if (err.response) {
            this.errorMessage = err.response.data.errorState.message
            this.subErrMsg = '쿠폰 번호 확인 후 다시 입력해주세요.'
            this.isRefresh = false
            if (err.response.data.errorState.reason == '사용 완료') {
              this.subErrMsg = '마이페이지의 쿠폰함을 확인해주세요.'
              this.isRefresh = true
            }
            this.toggleErrorModal()
          }
        })
    },
    closeErrorModal() {
      if (this.isRefresh) {
        this.$router.go()
      }
      this.showErrorModal = false
    },
    // hint
    toggleErrorModal() {
      this.showErrorModal = !this.showErrorModal
    },
    expiredDateFormat(expired) {
      let tmp = expired.split(/-| |:/)
      let dateString = tmp[0]
        .concat('.')
        .concat(tmp[1])
        .concat('.')
        .concat(tmp[2])
        .concat(' ')
        .concat(tmp[3])
        .concat(':')
        .concat(tmp[4])
        .concat('까지')
      return dateString
    },
    moveToBook(bookCode) {
      if (bookCode) {
        this.$router.push({
          name: 'book_detail',
          params: { id: bookCode }
        })
      } else {
        this.$router.push({
          name: 'category_books',
          params: {
            category: 'A',
            subCategory: 'A'
          }
        })
      }
    },
    changeSortCoupon(sort) {
      this.$store.dispatch(ACCOUNT_DISCOUNT_GET_LIST, sort)
      this.sorting = sort
    },

    handleDiscountInput(event) {
      // first parmas: 사용자가 타입할때 들어오는 값
      // second parmas: 타입 시점의 cardNumber 전체 값
      const inputValue = event.target.value
      this.discntNo = this.discountFormatter(inputValue)
    },
    discountFormatter(inputValue) {
      // 입력값 정리
      let discntNo = inputValue.trim()

      // 허용되지 않는 문자 제거 (영문자, 숫자, 하이픈만 허용)
      discntNo = discntNo.replace(/[^A-Za-z0-9-]/g, '')

      // 하이픈으로 올바르게 포맷팅 (4자리씩 그룹화)
      // 먼저 모든 하이픈 제거
      const digitsOnly = discntNo.replace(/-/g, '')

      // 4자리씩 그룹화하여 하이픈 추가
      const formattedValue =
        digitsOnly.match(/[A-Za-z0-9]{1,4}/g)?.join('-') || digitsOnly

      return formattedValue
    }
  }
}
</script>
<style src="@/assets/css/page_member.css" scoped></style>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
.input_wrap {
  display: flex;
  justify-content: center;
}
.lb_wrap {
  position: relative;
  width: 460px;
  height: 48px;
  input {
    // color: transparent;
    position: absolute;
    z-index: 99;
    left: 0;
    top: 0;
    margin: 0;
    background: transparent;
    padding-left: 16px;
  }
  .ab_text {
    z-index: 98;
    padding-left: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    color: black;
    position: absolute;
    left: 0;
    top: 0;
  }
}
.ly_pop_content.ly_pop_msg.ly_txt {
  width: 540px;
  height: 257px;
  text-align: center;
  .ly_inner {
    padding-top: 60px !important;
    p {
      font-size: 16px;
      color: #778899;
    }
  }
}
input {
  width: 100%;
  height: 48px;
  margin-top: 40px;
  border: 1px solid #d5dff3;
  box-sizing: border-box;
  border-radius: 12px;
}

.member_st {
  .inner.df {
    display: flex;
  }
  .box_title {
    width: 45%;
    h2 {
      margin-bottom: 2rem;
    }
    .box_btn {
      width: 100%;
      height: 56px;
      margin-top: 16px;
      background-color: #008df3;
      border-radius: 12px;
      border: none;
      .an_t {
        font-size: 18px;
        line-height: 56px;
      }
    }
  }
}

.box_title:last-child {
  margin-right: 0;
}

.btnWrap {
  // margin-top: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
  .box_btn {
    width: 50%;
    height: 56px;
    // width: 76px;
    // height: 40px;
    .an_t {
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 18px;
      line-height: 56px;
      letter-spacing: 0;
    }
  }
}

.disabled {
  background-color: #778899;
  border-color: #778899;
}
.member_st .box_title {
  display: block !important;
  .an_t {
    font-size: 16px;
  }
}

.clear {
  clear: both;
}
.section2 {
  .tit_box {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #ddd;
    padding-top: 5px;
    h1 {
      color: #0f638f;
      margin: 0.5em 0;
      float: left;
      b {
        color: #36a5c2;
      }
    }
    ul {
      float: right;
      margin-top: 27px;
      li {
        display: inline-block;
        margin-right: 10px;
        font-size: 18px;
        color: #666;
        cursor: pointer;
      }
      li.active {
        color: #000;
        font-weight: 500;
      }
    }
  }

  .coupon_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 20px 0;
    .coupon_box {
      background-color: #36a5c2;
      padding: 20px;
      border-radius: 20px;
      width: 48%;
      margin-right: 4%;
      margin-bottom: 30px;
      // float: left;
      color: #fff;
      min-height: 140px;
      div p {
        display: inline-block;
      }

      div div {
        display: inline-block;
        letter-spacing: 0.5px;
        margin-top: 10px;
      }
      .discount_rate {
        color: #ffff01;
        font-size: 3.3rem;
        margin-bottom: 15px;
      }
      .book_name {
        float: right;
        font-size: 1.5rem;
        padding-right: 5px;
        margin-top: 10px;
        max-width: calc(100% - 140px);
        max-height: 70px;
        width: 270px;
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        word-break: keep-all;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        // overflow: hidden;
        // text-overflow: ellipsis;
      }

      .bt {
        float: right;
        color: #196d82;
        background-color: #fff;
        border-radius: 30px;
        padding: 7px 30px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
      }
    }
    .coupon_box:nth-child(2n) {
      margin-right: 0;
    }
  }
}

@media screen and (max-width: 820px) {
  .section2 .tit_box ul {
    margin-top: 19px;
  }
  .section2 .coupon_list .coupon_box {
    max-width: 350px;
    div div {
      margin: 10px 0 10px;
    }

    .book_name {
      font-size: 1.2rem;
      padding-right: 0px;
      max-height: 50px;
    }

    .discount_rate {
      font-size: 2.8rem;
    }
  }

  .section2 .coupon_list .coupon_box:nth-child(2n) {
    margin-right: auto;
  }

  .section2 .coupon_list .coupon_box .bt {
    padding: 5px 20px;
    font-size: 0.8rem;
  }
}

@media screen and (max-width: 650px) {
  .section .inner {
    padding-top: 20px;
    &.df {
      flex-direction: column;
      align-items: center;
    }
  }
  .member_st .box_title {
    width: 100%;
    h2 {
      margin-bottom: 1rem;
    }
  }
  .section2 .tit_box ul li {
    font-size: 14px;
  }
}
@media screen and (max-width: 480px) {
  .section2 .coupon_list {
    flex-direction: column;
    align-items: center;
    gap: 20px;
    .coupon_box {
      width: 100%;
      margin: 0;
      &:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}
@media screen and (max-width: 400px) {
  .section2 .tit_box ul,
  .section2 .tit_box h1 {
    float: none;
  }

  .section2 .tit_box ul {
    margin-bottom: 10px;
  }
}
</style>
